export default "__VITE_ASSET__ac9835ac__"